import {
  Directive,
  ElementRef,
  Input,
  HostListener
} from '@angular/core';

type EventMessageMap = { [event: string]: string };

@Directive({
  selector: '[appLogEvent]'
})
export class LogEventDirective {
  @Input('appLogEvent') messageMap: string | EventMessageMap | undefined;
  @Input() showTimeStamp: boolean = true;

  constructor(private el: ElementRef) { }

  @HostListener('click')
  handleClick(): void {
    this.logEvent('click');
  }

  private logEvent(eventName: string): void {
    const message =
      typeof this.messageMap === 'string'
        ? this.messageMap
        : this.messageMap?.[eventName] || this.resolveMessage(eventName) || `User triggered '${eventName}'`;

    console.log(`${this.showTimeStamp ? message+' ---> Time Stamp: '+new Date().toISOString() :  message }`);

  }

  private resolveMessage(eventName: string): string {
    const element = this.el.nativeElement as HTMLElement;
    const label =
      element.getAttribute('title') ||
      element.getAttribute('aria-label') ||
      element.getAttribute('value') ||
      element.innerText?.trim();

    return label ? `User ${eventName}ed '${label}'` : '';
  }
}
